(() => {
  const policyPath = '/policies/shipping-policy';
  const apiUrl = 'https://linadream.com/api/shopify/public/delivery-deadline';
  const styleId = 'jp-order-deadline-lookup-styles';
  const containerId = 'jp-order-deadline-lookup';

  const isShippingPolicyPage = () => {
    const pathname = window.location.pathname.replace(/\/+$/, '');
    return pathname === policyPath || pathname.endsWith(policyPath);
  };

  const parseDate = (value) => {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return null;
    }

    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day, 12, 0, 0, 0);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }
    return date;
  };

  const addStyles = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .jp-order-deadline-lookup {
        box-sizing: border-box;
        width: min(100% - 2rem, 48rem);
        margin: 2.5rem auto;
        padding: clamp(1.25rem, 4vw, 2rem);
        border: 1px solid rgb(var(--color-foreground-rgb, 0 0 0) / 0.16);
        background: rgb(var(--color-background-rgb, 255 255 255) / 0.72);
        color: rgb(var(--color-foreground-rgb, 0 0 0) / 0.88);
      }
      .jp-order-deadline-lookup *,
      .jp-order-deadline-lookup *::before,
      .jp-order-deadline-lookup *::after {
        box-sizing: border-box;
      }
      .jp-order-deadline-lookup__title {
        margin: 0 0 0.5rem;
        color: inherit;
        font: inherit;
        font-size: clamp(1.2rem, 3vw, 1.55rem);
        font-weight: 650;
        line-height: 1.3;
      }
      .jp-order-deadline-lookup__description {
        margin: 0 0 1.25rem;
        color: rgb(var(--color-foreground-rgb, 0 0 0) / 0.72);
      }
      .jp-order-deadline-lookup__form {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
        align-items: end;
      }
      .jp-order-deadline-lookup__field {
        display: grid;
        gap: 0.4rem;
        min-width: 0;
        font-size: 0.95rem;
        font-weight: 600;
      }
      .jp-order-deadline-lookup__input {
        width: 100%;
        min-height: 3rem;
        padding: 0.65rem 0.8rem;
        border: 1px solid rgb(var(--color-foreground-rgb, 0 0 0) / 0.3);
        border-radius: 0;
        background: rgb(var(--color-background-rgb, 255 255 255) / 1);
        color: inherit;
        font: inherit;
        font-weight: 400;
      }
      .jp-order-deadline-lookup__input:focus-visible,
      .jp-order-deadline-lookup__button:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 2px;
      }
      .jp-order-deadline-lookup__button {
        grid-column: 1 / -1;
        justify-self: start;
        min-height: 2.9rem;
        padding: 0.7rem 1.3rem;
        border: 1px solid currentColor;
        border-radius: 0;
        background: rgb(var(--color-foreground-rgb, 0 0 0) / 1);
        color: rgb(var(--color-background-rgb, 255 255 255) / 1);
        cursor: pointer;
        font: inherit;
        font-weight: 650;
      }
      .jp-order-deadline-lookup__button:disabled {
        cursor: wait;
        opacity: 0.65;
      }
      .jp-order-deadline-lookup__result {
        min-height: 1.5em;
        margin: 1rem 0 0;
        font-weight: 650;
      }
      .jp-order-deadline-lookup__result[data-state="error"] {
        font-weight: 400;
      }
      @media (max-width: 640px) {
        .jp-order-deadline-lookup {
          width: calc(100% - 2rem);
          margin-block: 1.75rem;
        }
        .jp-order-deadline-lookup__form {
          grid-template-columns: minmax(0, 1fr);
        }
        .jp-order-deadline-lookup__button {
          width: 100%;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const createLookup = () => {
    if (!isShippingPolicyPage() || document.getElementById(containerId)) return;

    const policyBody = document.querySelector('.shopify-policy__body');
    if (!policyBody) return;

    addStyles();

    const section = document.createElement('section');
    section.id = containerId;
    section.className = 'jp-order-deadline-lookup';
    section.setAttribute('aria-labelledby', 'jp-order-deadline-lookup-title');

    const title = document.createElement('h2');
    title.id = 'jp-order-deadline-lookup-title';
    title.className = 'jp-order-deadline-lookup__title';
    title.textContent = 'Check your order’s delivery estimate';

    const description = document.createElement('p');
    description.className = 'jp-order-deadline-lookup__description';
    description.textContent =
      'Enter your order number and the email address used at checkout to view the latest estimated delivery date saved with your order.';

    const form = document.createElement('form');
    form.className = 'jp-order-deadline-lookup__form';
    form.noValidate = false;

    const orderLabel = document.createElement('label');
    orderLabel.className = 'jp-order-deadline-lookup__field';
    orderLabel.htmlFor = 'jp-order-deadline-order-number';
    orderLabel.append(document.createTextNode('Order number'));

    const orderInput = document.createElement('input');
    orderInput.id = 'jp-order-deadline-order-number';
    orderInput.className = 'jp-order-deadline-lookup__input';
    orderInput.name = 'orderNumber';
    orderInput.type = 'text';
    orderInput.autocomplete = 'off';
    orderInput.maxLength = 64;
    orderInput.required = true;
    orderInput.placeholder = '#US1004';
    orderInput.setAttribute('aria-required', 'true');
    orderLabel.append(orderInput);

    const emailLabel = document.createElement('label');
    emailLabel.className = 'jp-order-deadline-lookup__field';
    emailLabel.htmlFor = 'jp-order-deadline-email';
    emailLabel.append(document.createTextNode('Email used at checkout'));

    const emailInput = document.createElement('input');
    emailInput.id = 'jp-order-deadline-email';
    emailInput.className = 'jp-order-deadline-lookup__input';
    emailInput.name = 'email';
    emailInput.type = 'email';
    emailInput.autocomplete = 'email';
    emailInput.maxLength = 254;
    emailInput.required = true;
    emailInput.setAttribute('aria-required', 'true');
    emailLabel.append(emailInput);

    const submit = document.createElement('button');
    submit.className = 'jp-order-deadline-lookup__button';
    submit.type = 'submit';
    submit.textContent = 'Look up date';

    const result = document.createElement('p');
    result.className = 'jp-order-deadline-lookup__result';
    result.setAttribute('role', 'status');
    result.setAttribute('aria-live', 'polite');
    result.setAttribute('aria-atomic', 'true');

    form.append(orderLabel, emailLabel, submit);
    section.append(title, description, form, result);
    policyBody.insertAdjacentElement('afterend', section);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      submit.disabled = true;
      result.textContent = 'Checking your order…';
      result.dataset.state = 'loading';

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          referrerPolicy: 'no-referrer',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            orderNumber: orderInput.value.trim(),
            email: emailInput.value.trim(),
          }),
        });
        if (!response.ok) throw new Error('Lookup unavailable.');

        const payload = await response.json();
        const latestDate = parseDate(
          payload?.estimatedLatestDate || payload?.latestDate
        );
        if (!latestDate) {
          result.textContent =
            'We could not find a saved delivery estimate for those details.';
          result.dataset.state = 'error';
          return;
        }

        result.textContent = `Estimated latest delivery date: ${new Intl.DateTimeFormat(
          'en-US',
          { year: 'numeric', month: 'short', day: 'numeric' }
        ).format(latestDate)}`;
        result.dataset.state = 'success';
      } catch {
        result.textContent =
          'We could not check the delivery estimate right now. Please try again.';
        result.dataset.state = 'error';
      } finally {
        submit.disabled = false;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createLookup, { once: true });
  } else {
    createLookup();
  }
})();